export const routes = {
  authCallback: '/auth/callback',
  dashboard:    '/dashboard',
  users:        '/users',
  userDetail:   '/users/:id',
  userChats:    '/users/:id/chats',
  ai:           '/ai',
  infra:        '/infra',
  plans:        '/plans',
  compliance:        '/compliance',
  complianceAlerts:  '/compliance/alerts',
  complianceUsers:   '/compliance/users',
  complianceUser:    '/compliance/users/:id',
  complianceChecks:  '/compliance/checks',
} as const;

/**
 * The per-user risk view of the Compliance console. Registered only when `complianceEnabled` is on
 * (dev builds), so in production the path redirects to the dashboard like any unknown route.
 */
export function complianceUserPath(id: string): string {
  return `/compliance/users/${encodeURIComponent(id)}`;
}

/** The alerts inbox opened on one alert (`?alert=<id>`), so an alert can be linked to in a message. */
export function complianceAlertPath(id: string): string {
  return `/compliance/alerts?alert=${encodeURIComponent(id)}`;
}

/** Build the per-user deep-dive route path for a given user id. */
export function userDetailPath(id: string): string {
  return `/users/${encodeURIComponent(id)}`;
}

/**
 * The per-user chat-history screen. **Dev builds only** — the route is not registered when
 * `chatHistoryEnabled` is off, so this path 404s (redirects to the dashboard) in production.
 */
export function userChatsPath(id: string): string {
  return `/users/${encodeURIComponent(id)}/chats`;
}
